<template>
  <validation-observer v-slot="{ handleSubmit }" ref="contactObserver">
    <div class="modal-card enhancify grid-module">
      <header class="modal-card-head">
        <h2 class="modal-card-title">{{ template ? 'Edit E-mail template'
          : 'Create E-mail template' }}</h2>
        <button class="modal-close is-large" @click="$emit('close')"></button>
      </header>
      <section class="modal-card-body">
        <form>
          <validation-provider v-slot="{ errors }" rules="required">
            <b-field v-model="subject"
                     label="Subject"
                     :type="{ 'is-danger': errors.length }"
                     :message="errors + [ '&nbsp;' ]">
              <b-input v-model="subject"
                       maxlength="255"
                       @blur="()=>{ trimSpaces('subject') }"></b-input>
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors }" name="From address" rules="required|email">
            <b-field v-model="fromAddress"
                     label="From address"
                     :type="{ 'is-danger': errors.length }"
                     :message="errors + [ '&nbsp;' ]">
              <b-input v-model="fromAddress"
                       maxlength="255"
                       @blur="()=>{ trimSpaces('fromAddress') }"></b-input>
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors }" rules="required">
            <b-field
                    v-model="toAddress"
                    label="To address"
                    :type="{ 'is-danger': errors.length }"
                    :message="errors + [ '&nbsp;' ]"
            >
              <b-input v-model="toAddress"
                       maxlength="255"
                       @blur="()=>{ trimSpaces('toAddress') }"></b-input>
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors }">
            <b-field label="BCC"
                     :type="{ 'is-danger': errors.length }"
                     :message="errors + [ '&nbsp;' ]">
              <b-input v-model="bcc"
                       maxlength="255"
                       @blur="()=>{ trimSpaces('bcc') }"></b-input>
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors }" rules="required">
            <b-field
                    v-model.trim="body"
                    label="Body"
                    :type="{ 'is-danger': errors.length }"
                    :message="errors + [ '&nbsp;' ]"
            >
              <b-input v-model.trim="body" type="textarea" rows="3" name="body"></b-input>
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors }" rules="required">
            <b-field label="Type"
                     v-model="type"
                     :type="{ 'is-danger': errors.length }"
                     :message="errors + [ '&nbsp;' ]">
              <b-select v-model="type" expanded>
                <option v-for="type in types" v-bind:key="type.value" :value="type.id">
                  {{ type.value }}
                </option>
              </b-select>
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors }">
            <b-field label="Category"
                     v-model="category"
                     :type="{ 'is-danger': errors.length }"
                     :message="errors + [ '&nbsp;' ]">
              <b-select v-model="category" expanded>
                <option v-for="option in categories"
                        v-bind:key="option.id" :value="option.category">
                  {{ option.category }}
                </option>
              </b-select>
            </b-field>
          </validation-provider>
          <validation-provider v-if="!template" v-slot="{ errors }" rules="required">
            <b-field label="Used for"
                     v-model="usedFor"
                     :type="{ 'is-danger': errors.length }"
                     :message="errors + [ '&nbsp;' ]">
              <b-select v-model="usedFor" expanded
              >
              <option v-for="(item, index) in usedForList" v-bind:key="index" :value="item.id">
                {{ item.type }}
              </option>
              </b-select>
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors }">
            <b-field label="Description"
                     :type="{ 'is-danger': errors.length }"
                     :message="errors + [ '&nbsp;' ]">
              <b-input name="description"
                       maxlength="255"
                       v-model="description"></b-input>
            </b-field>
          </validation-provider>

          <b-field label="Unsubscribe">
            <b-checkbox v-model="unsubscribe"></b-checkbox>
          </b-field>

          <b-field label="Enabled">
            <b-checkbox v-model="enabled"></b-checkbox>
          </b-field>

        </form>
      </section>
      <footer class="modal-card-foot buttons is-right">
          <button class="button button-cancel" type="button" @click="cancel">Cancel</button>
          <button class="button is-success"
                  @click="handleSubmit(submit)">{{ template ? 'Update' : 'Add' }}</button>
      </footer>
    </div>
  </validation-observer>
</template>

<script>
import { get } from 'lodash';
import { mapMutations } from 'vuex';
import { createEmailTemplate, getFreeUsedFor, updateEmailTemplate } from '@/api/emails';
import * as MUTATIONS from '../../store/mutations';

export default {
  name: 'EmailTemplate',
  props: ['template', 'categories'],
  data() {
    return {
      id: this.template ? this.template.id : null,
      subject: this.template ? this.template.subject : '',
      fromAddress: this.template ? this.template.from : '',
      toAddress: this.template ? this.template.to : '',
      bcc: this.template ? this.template.bcc : '',
      body: this.template ? this.template.body : '',
      usedFor: this.template ? this.template.usedFor : null,
      type: this.template ? this.template.type : null,
      types: [{ id: 0, value: 'Internal' }, { id: 1, value: 'Common' }],
      category: this.template && this.template.category ? this.template.category.category : null,
      description: this.template ? this.template.description : null,
      enabled: this.template ? !!this.template.enabled : false,
      unsubscribe: this.template ? !!this.template.unsubscribe : false,
      usedForList: [],
    };
  },

  async mounted() {
    const { data } = await getFreeUsedFor();
    this.usedForList = data;
  },

  methods: {
    ...mapMutations({ preloader: MUTATIONS.SET_PRELOADER }),

    submit() {
      this.preloader(true);
      const submitFn = () => (this.id
        ? updateEmailTemplate({ ...this.$data })
        : createEmailTemplate({ ...this.$data }));

      submitFn().then((response) => {
        this.$emit('submit', { context: this, template: response.data });
        this.$emit('close');
      }).catch((err) => {
        const error = get(err, 'response.data.error', null);
        const message = get(err, 'response.data.message', 'An unexpected error occurred, please contact support@enhancify.com');
        if (error) {
          this.$buefy.toast.open({ message, type: 'is-danger', duration: 3000 });
        } else {
          this.$buefy.toast.open({ message: 'An unexpected error occurred, please contact support@enhancify.com' });
        }
      })
        .finally(() => this.preloader(false));
    },
    cancel() {
      this.$emit('close');
    },
    trimSpaces(field) {
      this[field] = this[field].replace(/([\s]+)/gu, ' ').replace(/^[\s]|[\s]$/gu, '');
    },

  },
};
</script>

<style scoped lang="stylus">

.modal-card
  .modal-card-title
    margin-bottom 0
    font-size 30px
  .modal-card-body
    max-height 600px

.modal-card-body >>> label.label
  font-weight 400
.buttons:last-child
  margin-bottom unset
.modal-card-body >>> textarea.textarea:not(.is-danger)
  box-shadow none
  border-color #8fa7b3
.modal-card-body >>> select
  border-color #8fa7b3
.modal-card-body >>> select:hover
  border-color #8fa7b3

footer.modal-card-foot
  padding 12px
  justify-content end
button.button
  width 135px
  height 46px
  border 1px solid #23D160
  font-size 19px
  text-transform uppercase
  margin-bottom 0
.button.button-cancel
  color #23D160
.button.button-cancel:hover
  background #17b548
  color white
.button.is-success
  border none
</style>
